import React, { FC, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import ButtonThird from "shared/Button/ButtonThird";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SearchInput from "components/NcInputNumber/SearchInput";

interface RoomsAndBedsFilterProps {
  bedrooms: string | number;
  bathrooms: string | number;
  onBedroomsChange: (value: number) => void;
  onBathroomsChange: (value: number) => void;
  onClear: (close: () => void) => void;
  onApply: (close: () => void) => void;
}

const RoomsAndBedsFilter: FC<RoomsAndBedsFilterProps> = ({
  bedrooms,
  bathrooms,
  onBedroomsChange,
  onBathroomsChange,
  onClear,
  onApply,
}) => {
  const isFilterApplied = Number(bedrooms) > 0 || Number(bathrooms) > 0;

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none transition-all ${
              open ? "!border-primary-500" : ""
            } ${
              isFilterApplied
                ? "bg-[#f5694b] text-white border-[#f5694b]"
                : "border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 hover:border-neutral-400 dark:hover:border-neutral-500 bg-white dark:bg-neutral-800"
            }`}
          >
            <span>Rooms & Beds</span>
            <i className="las la-angle-down ml-2"></i>
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md">
              <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                <div className="relative flex flex-col px-5 py-6 space-y-5">
                  <SearchInput
                    label="Bedrooms"
                    max={10}
                    value={Number(bedrooms) || 0}
                    onChange={onBedroomsChange}
                  />
                  <SearchInput
                    label="Bathrooms"
                    max={10}
                    value={Number(bathrooms) || 0}
                    onChange={onBathroomsChange}
                  />
                </div>

                <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                  <ButtonThird
                    onClick={() => onClear(close)}
                    sizeClass="px-4 py-2 sm:px-5"
                  >
                    Clear
                  </ButtonThird>

                  <ButtonPrimary
                    onClick={() => onApply(close)}
                    sizeClass="px-4 py-2 sm:px-5"
                  >
                    Apply
                  </ButtonPrimary>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default RoomsAndBedsFilter;